export enum LocalStorageKey {
  PrimaryRegion = 'uvo__primary_region',
  EpgRegion = 'uvo__epg_region',
  WasSkippedLandingNotificationPopup = 'uvo__was_skipped_landing_notification_popup',
}
